import { render, staticRenderFns } from "./BusServermanageServersList.vue?vue&type=template&id=ec7ddb10&scoped=true&"
import script from "./BusServermanageServersList.vue?vue&type=script&lang=js&"
export * from "./BusServermanageServersList.vue?vue&type=script&lang=js&"
import style0 from "./BusServermanageServersList.vue?vue&type=style&index=0&id=ec7ddb10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7ddb10",
  null
  
)

export default component.exports